const getVehicleFields = (self) => [
  {
    label: self.$t('routeOptimization.fields.licensePlate'),
    key: 'license_plate',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.vehicleType'),
    key: 'vehicle_type.type',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.boxType'),
    key: 'box_type.name',
    isSortable: true,
  },
]

export default getVehicleFields
